import type { Id } from "@repo/convex/dataModel";
import { buildProjectNavigationModel } from "@repo/shared";
import { useMemo } from "react";
import { buildFrameworkEntityAliases } from "../lib/framework-registry";
import {
  useProjectEntities,
  useProjectFrameworkStructure,
  useProjectRelations,
  useProjectTreeFolders,
} from "./useProjectData";

export function useProjectNavigationModel(projectId: Id<"projects"> | null) {
  const frameworkStructure = useProjectFrameworkStructure(projectId);
  const projectTreeFolders = useProjectTreeFolders(projectId);
  const entities = useProjectEntities(projectId);
  const relations = useProjectRelations(projectId);
  const aliases = useMemo(
    () => buildFrameworkEntityAliases(frameworkStructure ?? null),
    [frameworkStructure]
  );

  return useMemo(() => {
    if (!frameworkStructure || !aliases || !projectTreeFolders || !entities || !relations) {
      return null;
    }

    return buildProjectNavigationModel({
      structure: frameworkStructure,
      aliases,
      entities,
      projectTreeFolders,
      relations,
    });
  }, [aliases, entities, frameworkStructure, projectTreeFolders, relations]);
}
